const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13810",
    d: "M23.385 19.784 4.576.975a2.1 2.1 0 0 0-2.969 0l-.991.99a2.1 2.1 0 0 0 0 2.97l18.808 18.808a2.1 2.1 0 0 0 2.969 0l.99-.99a2.1 2.1 0 0 0 0-2.97zm0 0",
    transform: "translate(0 -.36)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13811",
    d: "M19.424.977.615 19.786a2.1 2.1 0 0 0 0 2.97l.99.99a2.1 2.1 0 0 0 2.97 0l18.81-18.809a2.1 2.1 0 0 0 0-2.969l-.99-.99a2.1 2.1 0 0 0-2.971 0zm0 0",
    transform: "translate(0 -.362)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.5c4ee5548b79c6e05eeaf6b6ef7e4b43.svg";
export { ForwardRef as ReactComponent };